
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'

interface ResetPassword {
  password: string,
  confirmPassword: string,
  id:string,
  tid: string,
  linkGuid: string,
}

const baseUrl = `${getBaseUrl()}/API/v3/Page`;
export const ResetpasswordApi = createApi({
    reducerPath: 'ResetpasswordApi', 
    tagTypes: ['RegistrationFormData'],
    baseQuery: getBaseQuery( baseUrl ),
    endpoints: (builder) => ({
        ResetPassword: builder.mutation<any, ResetPassword>({         
          query: (ResetPassword) => {
            const formattedData = new FormData();
            formattedData.append('Id', ResetPassword.id);
            formattedData.append('TimeId', ResetPassword.tid);
            formattedData.append('Password', ResetPassword.password);
            formattedData.append('ReenterPassword', ResetPassword.confirmPassword);
            formattedData.append('linkGuid', ResetPassword.linkGuid);
            return {
              url: '/password',
              method: 'PUT',
              body: formattedData, 
            };
          },
          transformResponse: (response: any) => {
            return response?.data || {}; 
          },
        }),
    }),
})

export const { useResetPasswordMutation } = ResetpasswordApi
